<template>
    <el-dialog
            title="发送短信对象"
            :visible.sync="smsObjDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="600px"
            center>
        <el-form :model="accountForm" :rules="rules" ref="accountForm" label-width="100px">
            <el-form-item label="发送短信对象" prop="name">
                <el-select v-model="accountForm.id" filterable placeholder="请选择发送短信对象" style="width: 100%">
                    <el-option
                            v-for="item in types"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('accountForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('accountForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>

import {updateWatchPeopleDetail8} from "@/api/service";
import {smsObjectList} from "@/utils/utils";

export default {
    name: "smsObjDialog",
    props: {
        smsObjDialog: {
            type: Boolean,
            default: false
        },
        s_id:{
            type: Number ,
            default: 0
        }
    },
    data() {

        return {
            types:smsObjectList,
            accountForm: {
                id: '',

            },
            rules: {
                id: [{required: true, message: '请选择发送短信对象', trigger: 'change'}],
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },

    },
    created() {

    },
    methods: {

        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await updateWatchPeopleDetail8(
                this.$route.params.id,
                this.accountForm.id,
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$emit("cancelDialog", true);
        }

    },
    watch: {
        s_id() {
            this.accountForm = {
                id: this.s_id?this.s_id:'',
            };
        },
    }
}
</script>

<style scoped lang="scss">

</style>
